import axios from "axios";

// Dedicated axios instance for all API calls — avoids polluting the global axios default.
// Extracted into its own module so it can be imported by both openapi/index.ts
// and tokenStore.ts without circular dependencies.
export const apiAxios = axios.create();
